import { createStyles, Theme } from '@material-ui/core'
import { darken, lighten } from '@material-ui/core/styles/colorManipulator'
import { makeStyles } from '@material-ui/core/styles'

export const useMainPageStatsSectionStyles = makeStyles((theme: Theme) => {
  const primary = theme.palette.primary.main

  return createStyles({
    root: {
      width: '100%',
    },
    row: {
      display: 'flex',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        flexWrap: 'wrap',
      },
    },
    cell: {
      flex: '1 1 0',
      minWidth: 0,
      minHeight: 120,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      padding: theme.spacing(3, 2),
      boxSizing: 'border-box',
      [theme.breakpoints.down('sm')]: {
        flex: '1 1 50%',
        minWidth: '50%',
      },
      [theme.breakpoints.down('xs')]: {
        flex: '1 1 100%',
        minWidth: '100%',
        minHeight: 100,
        padding: theme.spacing(2.5, 2),
      },
    },
    cell0: {
      backgroundColor: darken(primary, 0.26),
    },
    cell1: {
      backgroundColor: darken(primary, 0.05),
    },
    cell2: {
      backgroundColor: lighten(primary, 0.1),
    },
    cell3: {
      backgroundColor: lighten(primary, 0.2),
    },
    value: {
      color: theme.palette.common.white,
      fontWeight: 800,
      fontSize: 'clamp(1.5rem, 2.5vw + 0.75rem, 2.25rem)',
      lineHeight: 1.15,
      letterSpacing: '-0.02em',
    },
    valuePreloader: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'clamp(1.5rem, 2.5vw + 0.75rem, 2.25rem)',
      '& .MuiCircularProgress-root': {
        color: theme.palette.common.white,
      },
    },
    label: {
      color: theme.palette.common.white,
      fontWeight: 400,
      fontSize: 'clamp(0.8125rem, 1vw + 0.65rem, 1rem)',
      lineHeight: 1.35,
      marginTop: theme.spacing(0.75),
      maxWidth: 280,
    },
  })
})
